import React from 'react'
import { OptOutPage } from '../OptOutPage'

export const EmailOptOut: React.FC = () => {
  return <OptOutPage channel="email" />
}
